<script>
  import { onMount, setContext } from 'svelte';
  import { writable } from 'svelte/store';

  import Notification from '@utils/notification';
  import { getCurrentUserStore } from '@stores/current_user';
  import Track from '@utils/track';
  import ComponentEvents from '@utils/component-events';
  import Url from '@utils/url';

  import Viewport from '@components/Viewport.svelte';

  import RecRequestAjax from '@ajax/rec_request';
  // import RecObjectAjax from '@ajax/rec_object';

  import RecRequestGroupAjax from '@ajax/rec_request_group';
  import ConfigAjax from '@ajax/config';
  import BookmarkAjax from '@ajax/bookmark';

  import { browser } from '$app/environment';
  import { getGroupStore, initializeGroupStores } from '@stores/group';

  import { getGlobalStore } from '@stores/global';
  let recRequestGroupStore = getGlobalStore('recRequestGroupStore');
  let bookmarkStore = getGlobalStore('bookmarkStore');

  import Desktop from './group/Desktop.svelte';
  import Mobile from './group/Mobile.svelte';

  import ThankYouModal from '@app-components/modal/ThankYouModal.svelte';
  import WelcomeNoteModal from '@app-components/modal/WelcomeNoteModal.svelte';
  import AutoAddRecModal from '@app-components/modal/AutoAddRecModal.svelte';
  import VisitorBanner from '@app-components/VisitorBanner.svelte';
  import Unauthorized from './Unauthorized.svelte';

  import queryString from 'query-string';
  import NavigationHelper from '../utils/navigation-helper';
  import { saveUtmsToCookie } from '@utils/utm';

  export let slug;
  export let params = {};
  export let group;
  export let sections;
  export let recObjects;
  export let recs;
  export let accessDenied = false;
  export let unknownError = false;
  export let crawler = false;

  initializeGroupStores({
    recObjectsStore: recObjects,
    recsStore: recs,
    groupStore: group,
    sectionsStore: sections,
  });

  let groupStore = getGroupStore('groupStore');
  let configStore = getGroupStore('configStore');
  let recRequestsStore = getGroupStore('recRequestsStore');
  const allGroupRecsLoadedStore = writable(false);
  setContext('allGroupRecsLoadedStore', allGroupRecsLoadedStore);
  import jQuery from 'jquery';

  let currentUser = getCurrentUserStore('default');
  let mounted = false;

  let selectedGroupView = 'grid';

  const setSelectedGroupView = (newView) => {
    selectedGroupView = newView;

    Track.mapToggle({
      user: currentUser,
      group,
      enabled: newView == 'map',
      page: location.pathname,
    });
  };

  let loadedRecObjects = false;
  let loadedRecs = false;

  let showWelcomeNoteModal = false;
  let queryParams;
  let showThankYouModal = false;

  let documentClickTriggers = () => {
    ComponentEvents.trigger('close-all-options-menu');
    ComponentEvents.trigger('close-all-reviews');
  };

  let changeUrlIfUsernameIsStale = function () {
    if (groupStore) {
      let detailsKey = '/details';
      let groupPath = groupStore.path;
      let includesDetails = location.pathname.includes(detailsKey);

      if (groupPath != location.pathname.replace(detailsKey, '')) {
        Url.changeUrl(`${groupStore.path}${includesDetails ? detailsKey : ''}${location.search}`);
      }
    }
  };

  let loadConfig = async function () {
    configStore.set(await ConfigAjax.group());
  };

  let loadRecRequests = async function () {
    recRequestsStore.set(await RecRequestAjax.fetch(group));
  };

  let loadRecRequestGroup = async function () {
    if (currentUser && currentUser.api_token) {
      try {
        let recRequestGroup = await RecRequestGroupAjax.fetch();
        recRequestGroupStore.set(recRequestGroup);
      } catch {}
    }
  };

  let loadBookmarks = async function () {
    if (currentUser && currentUser.id && bookmarkStore && bookmarkStore.isNew) {
      bookmarkStore.set(await BookmarkAjax.fetch());
    }
  };

  let getOwner = function () {
    try {
      if (!group || !group.users) {
        return null;
      }

      let owners = group.users.filter((x) => x.role == 'admin');

      if (owners.length == 0) {
        return null;
      }

      let owner = owners[0];

      return owner;
    } catch {
      return null;
    }
  };

  let trackGroupView = function () {
    if (group) {
      let fromPath = NavigationHelper.getFromPath();
      let owner = getOwner();
      let selfSelect = owner && currentUser && owner.id == currentUser.id;

      return Track.groupView({ group, user: currentUser, fromPath, selfSelect });
    }
  };

  let seenRecObjects = [];
  let unsubRecObjectsRendered = ComponentEvents.on('group-rec-object-rendered', function (recObjectId) {
    if (currentUser && currentUser.id) {
      seenRecObjects.push(recObjectId);
    }
  });

  let seenInterval;
  let setIntervalSeenRecObjectsToServer = function () {
    seenInterval = setInterval(sendSeenRecObjectsToServer, 3000);
  };

  let sendSeenRecObjectsToServer = function () {
    if (seenRecObjects.length == 0 || !group || !group.id) {
      return;
    }

    Track.groupRecsViewed({ currentUser, recObjectIds: seenRecObjects, groupId: group.id });
    seenRecObjects = [];
  };

  let trackFacebookPixel = function () {
    if (typeof window !== 'undefined' && window.fbq !== undefined && (!currentUser || !currentUser.id)) {
      window.fbq('track', 'Subpage Page View Logged Out');
    }
  };

  if (browser) {
    saveUtmsToCookie();
  }

  onMount(() => {
    mounted = true;

    if (unknownError) {
      Notification.send({
        text: 'Something went wrong. We will look into this!',
        type: 'error',
      });
    }

    queryParams = queryString.parse(location.search);
    showThankYouModal = queryParams.rr_thanks == '1';

    loadConfig();

    if (group) {
      changeUrlIfUsernameIsStale();
      loadRecRequests();
      loadRecRequestGroup();
      loadBookmarks();
    }

    allGroupRecsLoadedStore.set(true);
    trackGroupView();
    setIntervalSeenRecObjectsToServer();

    jQuery(document).on('click.triggers', documentClickTriggers);
    let unsubGroup = groupStore.subscribe((x) => (group = x));

    showWelcomeNoteModal = group && group.welcome_note_enabled && group.welcome_note_editing != true;

    trackFacebookPixel();

    return () => {
      unsubGroup();
      unsubRecObjectsRendered();

      jQuery(document).off('click.triggers');
      sendSeenRecObjectsToServer();
      clearInterval(seenInterval);
    };
  });
</script>

<style style="text/scss" lang="scss">
  .layout-footer {
    text-align: center;
    margin-top: 20px;
  }

  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    .group-page-wrapper.unloaded {
      display: none;
    }
  }
</style>

<svelte:head>
  {#if group && group.name}
    <title>{group.seo_title || group.name}</title>
    {#if group.no_index}
      <meta name="robots" content="noindex" />
    {/if}
    <meta name="description" content={group.seo_description} />
    <link rel="canonical" href={Url.seoFriendlyUrl(group.url)} />
  {/if}

  {#if group && group.web_json_ld}
    {@html '<script type="application/ld+json">' + JSON.stringify(group.web_json_ld) + '</script>'}
  {/if}
</svelte:head>
<div class="group-page-wrapper {browser ? '' : 'unloaded'}" style={mounted || crawler ? '' : 'opacity: 0'}>
  <Viewport TABLET_MIN={870} let:tablet let:mobile let:desktop>
    <VisitorBanner
      mobile={mobile}
      tablet={tablet}
      desktop={desktop}
      groupId={group && group.id}
      fetchInviteCodeAutomaticallyUser={getOwner()} />

    {#if accessDenied}
      <Unauthorized slug={slug} mobile={mobile} params={params} />
    {:else}
      {#if browser}
        <ThankYouModal
          mobile={mobile}
          show={showThankYouModal}
          on:finished={() => {
            showThankYouModal = false;
            window.history.pushState('', '', group.path);
          }}
          on:close={() => {
            window.history.pushState('', '', group.path);
          }}
          buttonText="See your Benable list"
          header="Thank You!"
          message={queryParams?.rr_message} />
      {/if}
      {#if showWelcomeNoteModal}
        <WelcomeNoteModal
          mobile={mobile}
          groupContext={true}
          group={group}
          previewOnly={true}
          on:close={() => {
            showWelcomeNoteModal = false;
          }} />
      {/if}
      <!-- {#if showEmbedPostModal}
        <EmbedPostModal bind:showModal={showEmbedPostModal} mobile={mobile} group={group} user={currentUser} />
      {/if} -->

      {#if browser && loadedRecObjects && loadedRecs}
        <AutoAddRecModal mobile={mobile} />
      {/if}

      {#if mobile}
        <Mobile
          selectedGroupView={selectedGroupView}
          on:update-group-view={(event) => setSelectedGroupView(event.detail.newView)} />
      {:else}
        <Desktop
          selectedGroupView={selectedGroupView}
          on:update-group-view={(event) => setSelectedGroupView(event.detail.newView)} />
      {/if}
    {/if}
  </Viewport>
</div>
